import * as React from 'react';
export const googleadsSvg = React.forwardRef(function googleadsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.168 7.762c.232-.61.551-1.17 1.025-1.624 1.894-1.846 5.026-1.382 6.311.938.967 1.759 1.991 3.48 2.987 5.22 1.662 2.89 3.344 5.78 4.987 8.678 1.383 2.427-.116 5.49-2.86 5.905-1.683.252-3.258-.52-4.128-2.03-1.46-2.54-2.928-5.082-4.388-7.616a.874.874 0 0 0-.106-.154c-.155-.126-.223-.31-.32-.474-.647-1.14-1.314-2.27-1.96-3.402-.417-.734-.85-1.46-1.268-2.194a4.003 4.003 0 0 1-.53-2.126c.028-.386.076-.773.25-1.12v-.001Z',
      fill: '#3C8BD9',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.168 7.762a5.561 5.561 0 0 0-.184 1.063 4.176 4.176 0 0 0 .58 2.272 968.46 968.46 0 0 1 3.18 5.5c.097.163.174.327.271.482-.58 1.005-1.16 2-1.75 3.006-.81 1.401-1.623 2.813-2.445 4.214-.039 0-.048-.02-.058-.049-.01-.076.02-.145.04-.221.395-1.45.066-2.735-.929-3.837-.609-.668-1.382-1.044-2.27-1.17-1.16-.164-2.186.136-3.104.86-.164.125-.27.31-.464.406-.039 0-.058-.02-.068-.049.464-.802.92-1.604 1.383-2.405 1.913-3.325 3.827-6.65 5.75-9.966.02-.038.05-.067.068-.106Z',
      fill: '#FABC04',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.006 20.268c.184-.163.358-.338.55-.492 2.35-1.855 5.878-.512 6.39 2.425.125.706.058 1.383-.155 2.06a1.2 1.2 0 0 1-.038.163c-.088.155-.165.32-.26.474-.86 1.42-2.128 2.128-3.79 2.02-1.904-.134-3.403-1.566-3.664-3.46a3.867 3.867 0 0 1 .532-2.57c.097-.175.213-.33.32-.504.047-.038.028-.116.115-.116Z',
      fill: '#34A852',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.006 20.268c-.039.04-.039.107-.106.116-.01-.067.029-.105.067-.154l.039.038Z',
      fill: '#FABC04',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.753 24.424c-.04-.066 0-.116.038-.163l.039.038-.078.125Z',
      fill: '#E1C025',
    }),
  );
});
googleadsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var googleads = {
  category: 'brand',
  colorable: false,
  name: 'googleads',
  svg: googleadsSvg,
};
